import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import { getUserName } from '../../../common/utils/user/getUserName';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_USERS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: UserPageFilter
	) {
		getUsers(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				firstname
				lastname
				username
				phone
				defaultVehicle {
					id
					name
				}
				overrideMachinePhotoSchedule
				requireMachinePhotos
				machinesPhotosIntervalUnit
				machinesPhotosIntervalUnits

				overrideMarketPhotoSchedule
				requireMarketPhotos
				marketsPhotosIntervalUnit
				marketsPhotosIntervalUnits

				overrideHideFutureRunsFromDriversSetting
				hideFutureRunsFromDrivers
				
				overrideDefaultCashCollectionSetting
				defaultCashCollectionSetting
				defaultCashCollectionAbove
			}
			count
		}
	}
`;

const UserSelector = ({ query, initialFilter, ...props }) => {

	return (
		<SearchDropdownSelector
			query={query || GET_USERS}
			renderItem={item => <Text>{ getUserName(item) }</Text>}
			renderLabel={item => <Text>{ getUserName(item) }</Text>}
			placeholder="Select user"
			initialSortBy="firstname"
			initialFilter={{
				enabled: true,
				excludeFromSelectors: false,
				...initialFilter,
			}}
			{...props}
		/>
	);
};

export default UserSelector;
